import styled from "styled-components";

export const SelectChangeStatusStyle = styled.div`
    span{
        font-weight: 700 !important;
        font-size: 14px !important;
        line-height: 18px !important;
        color: #181A1C;
    }
`